/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* See LICENSE.md in the project root for license terms and full copyright notice.
*--------------------------------------------------------------------------------------------*/

import { PackageVersion } from "types/packageTypes";

export const latestPackageSet: PackageVersion = {
  "@itwin/appui-abstract": "^3.5.1",
  "@itwin/appui-layout-react": "^3.5.1",
  "@itwin/appui-react": "^3.5.1",
  "@itwin/components-react": "^3.5.1",
  "@itwin/core-bentley": "^3.5.1",
  "@itwin/core-common": "^3.5.1",
  "@itwin/core-frontend": "^3.5.1",
  "@itwin/core-geometry": "^3.5.1",
  "@itwin/core-i18n": "^3.5.1",
  "@itwin/core-markup": "^3.5.1",
  "@itwin/core-orbitgt": "^3.5.1",
  "@itwin/core-quantity": "^3.5.1",
  "@itwin/core-react": "^3.5.1",
  "@itwin/core-telemetry": "^3.5.1",
  "@itwin/frontend-devtools": "^3.5.1",
  "@itwin/hypermodeling-frontend": "^3.5.1",
  "@itwin/imodel-components-react": "^3.5.1",
  "@itwin/map-layers": "^3.5.1",
  "@itwin/map-layers-auth": "^3.5.1",
  "@itwin/presentation-common": "^3.5.1",
  "@itwin/presentation-components": "^3.5.1",
  "@itwin/presentation-frontend": "^3.5.1",
  "@itwin/webgl-compatibility": "^3.5.1",

  "@itwin/browser-authorization": "^0.5.1",
  "@itwin/grouping-mapping-widget": "^0.9.2",
  "@itwin/imodels-access-frontend": "^1.0.2",
  "@itwin/imodels-client-management": "^1.1.0",
  "@itwin/insights-client": "^0.3.4",
  "@itwin/itwinui-icons-react": "^1.16.0",
  "@itwin/itwinui-react": "^1.48.1",
  "@itwin/itwinui-illustrations-react": "^1.3.1",
  "@itwin/measure-tools-react": "^0.10.6",
  "@itwin/projects-client": "^0.7.0",
  "@itwin/property-grid-react": "^0.8.1",
  "@itwin/reality-data-client": "^0.9.0",
  "@itwin/tree-widget-react": "^0.6.0",
  "@itwin/viewer-react": "^3.3.1",
  "@itwin/web-viewer-react": "^3.1.1",
  "@itwin/imodel-browser-react": "^0.12.3",
  "@itwin/clash-detection-client": "^0.2.0",
  "@itwin/property-validation-client": "^0.3.3",
};
